<template>
  <RadioGroup v-model="form.accountOption">
    <RadioGroupLabel class="text-base font-medium text-gray-900">
      Select team option
    </RadioGroupLabel>

    <div class="grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-4">
      <RadioGroupOption
        v-for="accountOption in accountOptions"
        :key="accountOption.id"
        v-slot="{ checked, active }"
        as="template"
        :value="accountOption.id"
      >
        <div :class="[checked ? 'border-transparent' : 'border-gray-300', active ? 'ring-2 ring-indigo-500' : '', 'relative bg-white border rounded-lg shadow-sm p-4 flex cursor-pointer focus:outline-none']">
          <div class="flex-1 flex">
            <div class="flex flex-col">
              <RadioGroupLabel
                as="span"
                class="block text-sm font-medium text-gray-900"
              >
                {{ accountOption.title }}
              </RadioGroupLabel>
            </div>
          </div>
          <CheckCircleIcon
            :class="[!checked ? 'invisible' : '', 'h-5 w-5 text-indigo-600']"
            aria-hidden="true"
          />
          <div
            :class="[active ? 'border' : 'border-2', checked ? 'border-indigo-500' : 'border-transparent', 'absolute -inset-px rounded-lg pointer-events-none']"
            aria-hidden="true"
          />
        </div>
      </RadioGroupOption>
    </div>
  </RadioGroup>
</template>

<script>

import {
  RadioGroup, RadioGroupLabel, RadioGroupOption,
} from '@headlessui/vue';
import { CheckCircleIcon } from '@heroicons/vue/24/solid';

export default {
  name: 'AccountOption',

  components: {
    RadioGroup,
    RadioGroupLabel,
    RadioGroupOption,
    CheckCircleIcon,
  },

  props: ['form', 'accountOptions'],
  emits: ['update:form'],

  computed: {
    form: {
      get() {
        return this.form;
      },
      set(value) {
        this.$emit('update:form', value);
      },
    },
  },
};

</script>
